"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.space = void 0;

var _Theme = require("../Theme");

/**
 * A helper to easily access space values when not in a styled-components or
 * styled-systems context.
 */
var space = function space(spaceKey) {
  return parseInt(_Theme.themeProps.space[spaceKey], 10);
};

exports.space = space;
//# sourceMappingURL=space.js.map